import axios from "@/libs/api.request.js";

// 微信授权接口
export const getWechatAccessToken = (data) =>
  axios.request({
    url: `/platform-box-game/wechat/wechatAccessToken`,
    data,
    method: "post",
  })

// 获取注册 sdk 必要参数
export const getSdkParams = (data) => 
  axios.request({
    url: `/platform-box-game/wechat/???`,
    data,
    method: "post",
  })
